var map = {
	"./carnegie.svg": 249,
	"./columbia.svg": 250,
	"./laicode.svg": 154,
	"./laioffer-light.svg": 117,
	"./laioffer.svg": 251,
	"./newskyline-light.svg": 118,
	"./newskyline.svg": 252,
	"./njlg.svg": 253,
	"./peking.svg": 254,
	"./scdx.svg": 255,
	"./stanford.svg": 256,
	"./xunjing-light.svg": 75,
	"./xunjing.svg": 257,
	"./yale.svg": 258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;